/** Egim rengi — yumusak interpolate. */

const STOPS = [
  { t: 0, c: [34, 197, 94] },
  { t: 5, c: [132, 204, 22] },
  { t: 10, c: [234, 179, 8] },
  { t: 15, c: [249, 115, 22] },
  { t: 20, c: [239, 68, 68] },
  { t: 30, c: [185, 28, 28] },
];

function lerp(a, b, t) {
  return a + (b - a) * t;
}

export function getSlopeColorRgb(slope) {
  const s = Number(slope);
  if (!Number.isFinite(s)) return [148, 163, 184];
  if (s <= STOPS[0].t) return STOPS[0].c;
  for (let i = 1; i < STOPS.length; i += 1) {
    if (s <= STOPS[i].t) {
      const a = STOPS[i - 1];
      const b = STOPS[i];
      const u = (s - a.t) / Math.max(b.t - a.t, 1e-6);
      return [
        Math.round(lerp(a.c[0], b.c[0], u)),
        Math.round(lerp(a.c[1], b.c[1], u)),
        Math.round(lerp(a.c[2], b.c[2], u)),
      ];
    }
  }
  return STOPS[STOPS.length - 1].c;
}

export function getSlopeColorHex(slope) {
  const [r, g, b] = getSlopeColorRgb(slope);
  return `#${[r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('')}`;
}

export const SLOPE_3D_LEGEND = [
  { min: 0, max: 5, label: 'cok dusuk' },
  { min: 5, max: 10, label: 'dusuk' },
  { min: 10, max: 15, label: 'orta' },
  { min: 15, max: 20, label: 'dik' },
  { min: 20, max: null, label: 'cok dik' },
];
